module.exports = "<div>\n<img class=\"center\" width=\"90%\" src={{imgSrc}}>\n</div>\n"